import React, { useCallback, useState } from 'react';
import { LuCheck, LuCopy } from 'react-icons/lu';

import {
  COPY_ID_ACTION_PREFIX,
  COPY_ID_COPIED_LABEL,
} from 'constants/uiConstants';

interface CopyableIdProps {
  /** What the ID identifies, e.g. "Farm ID" — shown as "Copy Farm ID". */
  label: string;
  value: string;
}

/**
 * Staff troubleshooting control: copies an internal ID to the clipboard
 * without displaying it. Shown in hover tooltips, so it stays out of the way.
 */
const CopyableId: React.FC<CopyableIdProps> = ({ label, value }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  }, [value]);

  return (
    <button
      type="button"
      className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap border-none bg-transparent p-0 text-xs text-white hover:underline"
      onClick={handleCopy}
    >
      {copied ? <LuCheck size={12} /> : <LuCopy size={12} />}
      {copied ? COPY_ID_COPIED_LABEL : `${COPY_ID_ACTION_PREFIX} ${label}`}
    </button>
  );
};

export default CopyableId;
